type SoundId = 'eat' | 'golden' | 'boost' | 'portal' | 'die';

class AudioSys {
  private ctx: AudioContext | null = null;
  private master: GainNode | null = null;

  private ac(): AudioContext | null {
    try {
      if (!this.ctx) {
        const Ctor = window.AudioContext || (window as unknown as { webkitAudioContext: typeof AudioContext }).webkitAudioContext;
        this.ctx = new Ctor();
        this.master = this.ctx.createGain();
        this.master.gain.value = 0.22;
        this.master.connect(this.ctx.destination);
      }
      if (this.ctx.state === 'suspended') void this.ctx.resume();
      return this.ctx;
    } catch {
      return null;
    }
  }

  play(id: SoundId): void {
    const ctx = this.ac();
    const master = this.master;
    if (!ctx || !master) return;
    try {
      switch (id) {
        case 'eat':
          this.blip(ctx, master, 520, 0.07, 'sine', 0.18);
          break;
        case 'golden':
          this.arpeggio(ctx, master, [523, 659, 784], 0.08);
          break;
        case 'boost':
          this.arpeggio(ctx, master, [392, 523, 659, 784], 0.07);
          break;
        case 'portal':
          this.sweep(ctx, master, 280, 640, 0.16, 'sine', 0.16);
          break;
        case 'die':
          this.sweep(ctx, master, 320, 90, 0.38, 'triangle', 0.22);
          break;
      }
    } catch {
      /* autoplay restrictions */
    }
  }

  private blip(
    ctx: AudioContext,
    master: GainNode,
    freq: number,
    dur: number,
    type: OscillatorType,
    gain: number,
  ): void {
    const osc = ctx.createOscillator();
    const g = ctx.createGain();
    osc.type = type;
    osc.frequency.value = freq;
    g.gain.value = gain;
    g.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + dur);
    osc.connect(g);
    g.connect(master);
    osc.start();
    osc.stop(ctx.currentTime + dur);
  }

  private sweep(
    ctx: AudioContext,
    master: GainNode,
    from: number,
    to: number,
    dur: number,
    type: OscillatorType,
    gain: number,
  ): void {
    const osc = ctx.createOscillator();
    const g = ctx.createGain();
    osc.type = type;
    osc.frequency.setValueAtTime(from, ctx.currentTime);
    osc.frequency.exponentialRampToValueAtTime(Math.max(1, to), ctx.currentTime + dur);
    g.gain.value = gain;
    g.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + dur);
    osc.connect(g);
    g.connect(master);
    osc.start();
    osc.stop(ctx.currentTime + dur);
  }

  private arpeggio(ctx: AudioContext, master: GainNode, notes: number[], step: number): void {
    notes.forEach((freq, i) => {
      const osc = ctx.createOscillator();
      const g = ctx.createGain();
      osc.type = 'sine';
      osc.frequency.value = freq;
      const t = ctx.currentTime + i * step;
      g.gain.setValueAtTime(0.0001, t);
      g.gain.exponentialRampToValueAtTime(0.16, t + 0.02);
      g.gain.exponentialRampToValueAtTime(0.001, t + step);
      osc.connect(g);
      g.connect(master);
      osc.start(t);
      osc.stop(t + step + 0.02);
    });
  }
}

export const audio = new AudioSys();
